// extracted by mini-css-extract-plugin
export default {"loadingScreen":"LoadingScreen_loadingScreen__MM3eg","placeholderGrid":"LoadingScreen_placeholderGrid__e+sFr","placeholderCard":"LoadingScreen_placeholderCard__s16YK"};